/**
 * ARBOL DEL PILOTO CUBIERTA (MADERINCO-SELECCION-POR-TIPO-T1). GENERADO, no editar a mano:
 *   node generar-arbol-cubierta.cjs WORK-CUBIERTA-PREGUNTAS-v01_2026-10-19.json src/application/presupuestos/arbolCubierta.js
 * Fuente: Atenea, MADERINCO-PREGUNTAS-POR-TIPO-T1 (#30151), version 0.1, estado "propuesta_documental_validada_contra_catalogo_no_ingenieria".
 * sha256 del JSON: 82836b0ff0852af6b0a2071cbcda72c5ec2adb153d78e6b3d95b40f2dedfe2ea
 * Catalogo de origen: sha256 9d280ab4420e4439d68fc84a6a857dbaad0c624190a7726f936699ac3d09a867 (415283 B) = el catalogo aprobado y cargado en la plantilla.
 * Los ids (fuenteId) son los del catalogo: PlantillaItemDto.FuenteId los conserva tal cual (PresupuestoPlantillaService).
 * Compatibilidad tecnica validada: false (es una propuesta documental, no ingenieria).
 *
 * @module application/presupuestos/arbolCubierta
 */

export const ARBOL_VERSION = "0.1";
export const ARBOL_SHA256 = "82836b0ff0852af6b0a2071cbcda72c5ec2adb153d78e6b3d95b40f2dedfe2ea";

/** Q1: los tipos con nombre del cliente y sus variantes por id del catalogo (unidad y alcance de cada una). */
export const TIPOS = [
  {
    "codigo": "barro",
    "nombre": "Teja de barro",
    "variantes": [
      {
        "fuenteId": "APU:APU:B28",
        "unidad": "m2",
        "alcance": "alcance_por_confirmar"
      }
    ]
  },
  {
    "codigo": "shingle-roja-verde",
    "nombre": "Shingle roja o verde",
    "variantes": [
      {
        "fuenteId": "APU:APU:B29",
        "unidad": "m2",
        "alcance": "alcance_por_confirmar"
      }
    ]
  },
  {
    "codigo": "shingle-negra",
    "nombre": "Shingle negra",
    "variantes": [
      {
        "fuenteId": "APU:APU:B30",
        "unidad": "m2",
        "alcance": "alcance_por_confirmar"
      },
      {
        "fuenteId": "1347:PRESUPUESTO CASA:A12",
        "unidad": "M2",
        "alcance": "compuesto_con_estructura_explicita"
      }
    ]
  },
  {
    "codigo": "techoline",
    "nombre": "Techoline",
    "variantes": [
      {
        "fuenteId": "APU:APU:B31",
        "unidad": "m2",
        "alcance": "alcance_por_confirmar"
      }
    ]
  },
  {
    "codigo": "plana-sigma",
    "nombre": "Teja plana Sigma tabaco",
    "variantes": [
      {
        "fuenteId": "APU:APU:B32",
        "unidad": "m2",
        "alcance": "alcance_por_confirmar"
      }
    ]
  },
  {
    "codigo": "eternit",
    "nombre": "Teja Eternit",
    "variantes": [
      {
        "fuenteId": "APU:APU:B33",
        "unidad": "m2",
        "alcance": "alcance_por_confirmar"
      }
    ]
  },
  {
    "codigo": "manto",
    "nombre": "Cubierta en manto",
    "variantes": [
      {
        "fuenteId": "APU:APU:B34",
        "unidad": "m2",
        "alcance": "alcance_por_confirmar"
      }
    ]
  },
  {
    "codigo": "upvc",
    "nombre": "Teja UPVC gris",
    "variantes": [
      {
        "fuenteId": "1342:PRESUPUESTO CASA:A12",
        "unidad": "M2",
        "alcance": "compuesto_con_estructura_explicita"
      }
    ]
  },
  {
    "codigo": "monoroof",
    "nombre": "Teja termoacústica Monoroof",
    "variantes": [
      {
        "fuenteId": "1346:PRESUPUESTO - 1C:B12",
        "unidad": "M2",
        "alcance": "compuesto_con_estructura_explicita"
      },
      {
        "fuenteId": "1346:PRESUPUESTO - 1D:B12",
        "unidad": "M2",
        "alcance": "compuesto_con_estructura_explicita"
      },
      {
        "fuenteId": "4546:PRESUPUESTO CASA:A12",
        "unidad": "M2",
        "alcance": "compuesto_con_estructura_explicita"
      }
    ]
  },
  {
    "codigo": "plano",
    "nombre": "Techo plano impermeabilizado",
    "variantes": [
      {
        "fuenteId": "1346:PRESUPUESTO - 1C:B13",
        "unidad": "Gnral",
        "alcance": "compuesto_con_estructura_explicita"
      },
      {
        "fuenteId": "1346:PRESUPUESTO - 1D:B13",
        "unidad": "Gnral",
        "alcance": "compuesto_con_estructura_explicita"
      }
    ]
  }
];

/** Q2 (obligatoria): como queda resuelta la estructura. Responderla no compra nada. */
export const Q2 = [
  {
    "codigo": "incluida",
    "texto": "Ya viene incluida en esta solución"
  },
  {
    "codigo": "existente",
    "texto": "Ya existe y se conserva, pendiente de comprobar"
  },
  {
    "codigo": "falta",
    "texto": "Hace falta presupuestarla según diseño"
  },
  {
    "codigo": "no_definido",
    "texto": "Todavía no definido"
  }
];

/** Q3 (opcional): que complemento revisar. Abrir no agrega. */
export const Q3 = [
  {
    "codigo": "claraboya",
    "texto": "Entrada de luz: claraboya",
    "palabras": [
      "claraboya"
    ]
  },
  {
    "codigo": "agua",
    "texto": "Evacuación de agua: canoa o bajantes",
    "palabras": [
      "canoa",
      "bajante"
    ]
  },
  {
    "codigo": "remates",
    "texto": "Remates: tapas",
    "palabras": [
      "tapa",
      "remate"
    ]
  },
  {
    "codigo": "ninguno",
    "texto": "Ninguno por ahora",
    "palabras": []
  }
];

/** Ids que Atenea clasifico como complemento por revisar (los unicos candidatos de Q3). */
export const COMPLEMENTOS = ["1342:PRESUPUESTO CASA:A13","1342:PRESUPUESTO CASA:A14","1342:PRESUPUESTO CASA:A15","1342:PRESUPUESTO CASA:A16","1346:PRESUPUESTO - 1C:B14","1346:PRESUPUESTO - 1C:B15","1346:PRESUPUESTO - 1C:B16","1346:PRESUPUESTO - 1C:B17","1346:PRESUPUESTO - 1D:B14","1346:PRESUPUESTO - 1D:B15","1346:PRESUPUESTO - 1D:B16","1346:PRESUPUESTO - 1D:B17","1346:PRESUPUESTO - 1D:B18","1347:PRESUPUESTO CASA:A13","1347:PRESUPUESTO CASA:A14","1347:PRESUPUESTO CASA:A15","4546:PRESUPUESTO CASA:A13","4546:PRESUPUESTO CASA:A14","4546:PRESUPUESTO CASA:A15","4546:PRESUPUESTO CASA:A16","4546:PRESUPUESTO CASA:A17"];

/** Ids de estructura mixta muros/cubierta: fuera del piloto (no se ofrecen). */
export const FUERA_DEL_PILOTO = ["1346:PRESUPUESTO - 1C:B43","1346:PRESUPUESTO - 1D:B44"];

/** Todos los ids de tipo de cubierta del arbol (para medir la cobertura servida). */
export const IDS_DE_TIPO = ["1342:PRESUPUESTO CASA:A12","1346:PRESUPUESTO - 1C:B12","1346:PRESUPUESTO - 1C:B13","1346:PRESUPUESTO - 1D:B12","1346:PRESUPUESTO - 1D:B13","1347:PRESUPUESTO CASA:A12","4546:PRESUPUESTO CASA:A12","APU:APU:B28","APU:APU:B29","APU:APU:B30","APU:APU:B31","APU:APU:B32","APU:APU:B33","APU:APU:B34"];
